// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../node_modules/pretendard/dist/web/static/pretendard.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family:
    "Pretendard",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media print {
  button {
    display: none !important;
  }

  html,
  body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .page-break {
    page-break-before: always !important; /* 이 요소 앞에서 페이지를 나눕니다 */
  }

  /* @page {
    size: A4;
    margin: 10mm;
    margin-top: 0;
    margin-bottom: 0;
  } */

  @page {
    size: A4 landscape;
    margin: 15mm;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT;;;;;;;;;;;;cAYY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,0BAA0B;IAC1B,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC,EAAE,uBAAuB;EAC/D;;EAEA;;;;;KAKG;;EAEH;IACE,kBAAkB;IAClB,YAAY;EACd;AACF","sourcesContent":["@import \"~pretendard/dist/web/static/pretendard.css\";\n\nbody {\n  margin: 0;\n  font-family:\n    \"Pretendard\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n@media print {\n  button {\n    display: none !important;\n  }\n\n  html,\n  body {\n    height: initial !important;\n    overflow: initial !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .page-break {\n    page-break-before: always !important; /* 이 요소 앞에서 페이지를 나눕니다 */\n  }\n\n  /* @page {\n    size: A4;\n    margin: 10mm;\n    margin-top: 0;\n    margin-bottom: 0;\n  } */\n\n  @page {\n    size: A4 landscape;\n    margin: 15mm;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
